// src/lib/crashOverlay.ts
let installed = false;

function safeToString(err: unknown) {
  if (err instanceof Error) return `${err.name}: ${err.message}\n\n${err.stack ?? ""}`;
  try {
    return typeof err === "string" ? err : JSON.stringify(err, null, 2);
  } catch {
    return String(err);
  }
}

function ensureOverlay() {
  let el = document.getElementById("forkcast-crash-overlay") as HTMLDivElement | null;
  if (el) return el;

  el = document.createElement("div");
  el.id = "forkcast-crash-overlay";
  el.style.position = "fixed";
  el.style.inset = "0";
  el.style.zIndex = "2147483647";
  el.style.background = "#fff";
  el.style.color = "#111";
  el.style.padding = "16px";
  el.style.fontFamily = "monospace";
  el.style.whiteSpace = "pre-wrap";
  el.style.overflow = "auto";
  el.style.display = "none";

  document.body.appendChild(el);
  return el;
}

export function showCrashOverlay(title: string, err: unknown) {
  try {
    const el = ensureOverlay();
    el.style.display = "block";
    el.textContent =
      `${title}\n\n` +
      safeToString(err) +
      `\n\nURL:\n${location.href}\n\nUserAgent:\n${navigator.userAgent}`;
  } catch {
    // last resort: do nothing
  }
}

export function installCrashOverlay() {
  if (installed) return;
  installed = true;

  // Window-level errors (syntax, runtime, promise rejections)
  window.addEventListener("error", (e) => {
    const anyE: any = e as any;
    showCrashOverlay("Window error", anyE?.error ?? anyE?.message ?? e);
  });

  window.addEventListener("unhandledrejection", (e) => {
    showCrashOverlay("Unhandled promise rejection", (e as PromiseRejectionEvent).reason);
  });

  // Optional: capture console.error (helps when React logs instead of throwing)
  const orig = console.error;
  console.error = (...args: any[]) => {
    orig(...args);
    try {
      // don’t spam overlay for every log; only if it looks like an Error
      const first = args?.[0];
      if (first instanceof Error) showCrashOverlay("console.error(Error)", first);
    } catch {}
  };
}
